import React from 'react';
import styled from 'styled-components';
import { Flex, Box, TextBox, Heading2 } from 'src/kit';

export { default as StyledQuote } from './StyledQuote';
export { default as AnimateFlex } from './AnimateFlex';

export const LText = styled(TextBox)``;
LText.defaultProps = {
  as: 'span',
  mt: 0,
  mb: 15,
  color: 'text',
  fontSize: { xs: 1, md: 3 },
  fontWeight: 'normal',
  lineHeight: 1.6,
  width: '100%' // IE fix
};

export const Section = props => <Box as="section" py={{ xs: 60, md: 100, lg: 130 }} {...props} />;

export const SubSection = props => (
  <Flex flexDirection={{ xs: 'column', lg: 'row' }} justifyContent="center" px={{ xs: 0, md: 100, lg: 0 }} {...props} />
);

export const CustomFlex = props => (
  <Flex flexDirection={{ xs: 'column', lg: 'row' }} justifyContent="center" {...props} />
);

export const CustomBox = props => (
  <TextBox width={{ lg: 0.5 }} minWidth={{ lg: 0.5 }} px={{ xs: 20, sm: 30, md: 40 }} mx={0} {...props} />
);

export const CustomHeading2 = props => <Heading2 px={{ xs: 0, sm: 30 }} {...props} />;

export const CustomText = props => <LText fontSize={{ xs: 1, sm: 2 }} {...props} />;

export const ZoomBox = styled(Box)`
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: scale(1.2);
  }
`;
